const CompletedTileBlock = ({ count }: { count: number }) => (
  <div className="w-full bg-[#DDD] px-[3px] py-[4px] rounded text-[#4B4B4B]">완료 {count}</div>
);

export default CompletedTileBlock;
